module.exports = __webpack_public_path__ + "img/back03.745ed9f3.jpg";